// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2nCLQ","modalForm":"UpgradeEpcsModal_modalForm__2dX3p","modalFooter":"UpgradeEpcsModal_modalFooter__3jhN1"};